<template>
  <div>
    <h3 class="font-bold text-xl mb-4">
      Coș
    </h3>
    <div class="flex flex-col mb-8" v-if="$page.cart.count">
      <div v-for="(item,index) in $page.cart.items" :key="index" class="flex items-center py-2">
        <div class="w-3/4 flex flex-row items-center">
          <img :src="item.attributes.image" class="w-16 h-16 mr-2" :alt="`Image of ${item.name}`"/>
          <div class="flex flex-col">
            <span>{{ item.name }}</span>
            <span class="text-gray-700 text-sm">{{ item.attributes.artist }}</span>
          </div>
        </div>
        <div class="flex flex-row items-center justify-end w-1/4">
          <span class="mr-4 font-bold">&euro; {{ number_format(item.price, 0, 0, '.') }}</span>
          <span class="cursor-pointer text-gray-700 hover:text-gray-900 transition ease-in-out duration-150"
                @click="removeFromCart(item.id)"><svg xmlns="http://www.w3.org/2000/svg" class="fill-current"
                                                      viewBox="0 0 24 24" width="24" height="24"><path
              class="heroicon-ui"
              d="M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z"/></svg></span>
        </div>
      </div>
    </div>
    <div class="flex justify-center items-center p-10" v-else>
      <span class="text-xl text-gray-700" v-html="$t('cart.cart_empty')"></span>
    </div>
    <div v-if="$page.cart.count" class="flex flex-1 justify-end">
      <div class="flex flex-col">
        <span class="text-xl mb-2 self-end">Total: <span
            class="font-bold">&euro; {{ number_format($page.cart.total, 0, 0, '.') }}</span></span>
        <span v-if="$page.auth.user">
            <inertia-link :href="route('shop.checkout')" class="btn-gray mt-4">Finalizează cumpărăturile</inertia-link>
            </span>
        <span v-else>
          <a style="border: 1px solid #343a40; padding:4px 12px;color:#343a40" class="btn-white mt-4"
             :href="route('login')">{{ $t('account.login') }}</a>
                    <a class="btn-white mt-4 text-white"
                       style="border: 1px solid black; padding:4px 12px;background-color: rgb(52, 58, 64);"
                       :href="route('shop.register')">{{ $t('account.register') }}</a>
          </span>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo() {
    return {
      title: 'Coș',
      showUpdate: false,
      meta: [
        {name: 'robots', content: 'noindex, nofollow, nosnippet, noarchive'},
        {name: 'googlebot', content: 'noindex, nofollow, nosnippet, noarchive'}
      ]
    }
  },
  layout: Layout,
  components: {
    Layout,
    SelectInput
  },
  methods: {
    removeFromCart(id) {
      this.$inertia.post(this.route('shop.cart.remove', id));
      let quantity = Object.keys(this.$page.cart.items).length - 1;
      let carts = document.querySelectorAll('sup.cart_quantity');
      for (let i = 0, len = carts.length; i < len; ++i) {
        let cart = carts[i];
        cart.innerHTML = quantity;
      }
    },
    setQuantity(quantity, id) {
      this.$inertia.put(this.route('shop.cart.update', id), {
        quantity: quantity
      })
    },
    number_format(number, decimals, dec_point, thousands_sep) {
      // Strip all characters but numerical ones.
      number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
      var n = !isFinite(+number) ? 0 : +number,
          prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
          sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
          dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
          s = '',
          toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
          };
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
      }
      if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
      }
      return s.join(dec);
    }
  }
}
</script>
